import qs from 'qs';

function getQAID() {
  const host = location.hostname;
  if (
    host.indexOf('fe-adv-sales-crm-qa.cpc-static-upload.qutoutiao.net') !== -1
    ||
    host.indexOf('localhost') !== -1
  ) {
    return 'development';
  }
  return CODE_EVN;
}

// 登录SSO
// 登录成功后 SSO 会给 CRM 颁发一个 code
export function loginBySSO() {
  const hostname = DOMAIN_API.perm.sso;
  const idMapping = {
    development: 'sales-crm-qa',
    preview: 'sales-crm',
    production: 'sales-crm',
  };
  const uriMapping = {
    development: location.href,
    preview: location.protocol + '//fe-adv-sales-crm-pre.cpc-static-upload.qutoutiao.net/login',
    production: location.protocol + '//crm.aiclk.com/login',
  };

  const params = {
    client_id: idMapping[getQAID()],
    redirect_uri: uriMapping[CODE_EVN],
    state: 1,
  };

  const uri = `//${hostname}/api/oauth/sso?${qs.stringify(params)}`;

  location.href = uri;
}

// 登出SSO
export function logoutBySSO() {
  const hostname = DOMAIN_API.perm.sso;
  const idMapping = {
    development: 'sales-crm-qa',
    preview: 'sales-crm',
    production: 'sales-crm',
  };
  const params = {
    client_id: idMapping[CODE_EVN],
  };
  const uri = `//${hostname}/api/oauth/login-out?${qs.stringify(params)}`;
  location.href = uri;
}
